import { useRequest } from '~/repositories'

/** Registers a new user account. */
export const postRegister = (payload: any) => {
	return useRequest('post', `/v1/auth/register/`, payload)
}

/** Authenticates a user with email/password, returning an access token on success. */
export const postLogin = (payload: any) => {
	return useRequest('post', `/v1/auth/login/`, payload)
}

/** Exchanges a one-time login token for an access token (magic-link flow). */
export const getLoginToken = (payload: { token: string; email: string }) => {
	return useRequest('get', `/v1/auth/login-with-token/${payload.token}`, {
		email: payload.email,
	})
}

/** Exchanges a one-time login code for an access token (OTP flow). */
export const getLoginCode = (payload: { code: string; email: string }) => {
	return useRequest('get', `/v1/auth/login-with-code/${payload.code}`, {
		email: payload.email,
	})
}

/** Activates a newly registered account via the email verification token. */
export const getActivationUser = (token: string) => {
	return useRequest('get', `/v1/auth/activate/${token}`, {})
}

/** Activates a newly registered account via an activation code (alternative to token link). */
export const getActivationUserWithCode = (token: string) => {
	return useRequest('get', `/v1/auth/activate-code/${token}`, {})
}

/** Resends the account-activation email to the given address. */
export const postResendActivation = (email: any) => {
	return useRequest('post', `/v1/auth/resend-activation`, email)
}

// ----------------------------------------

/** Initiates the password-reset flow by sending a reset email. */
export const postForgotPassword = (payload: any) => {
	return useRequest('post', `/v1/auth/password-reset/`, payload)
}

/** Validates the password-reset token before allowing the user to set a new password. */
export const postValidateTokenPassword = (payload: any) => {
	return useRequest('post', `/v1/auth/password-reset/validate-token/`, payload)
}

/** Confirms the password reset by submitting the new password together with the reset token. */
export const postUpdatePassword = (payload: any) => {
	return useRequest('post', `/v1/auth/password-reset/confirm/`, payload)
}

/** Authenticates or registers a user via a Google OAuth2 access token. */
export const postAuthGoogle = (payload: any) => {
	return useRequest('post', `/v1/auth/google/`, payload)
}

export default {
	postRegister,
	postLogin,
	getLoginToken,
	getLoginCode,
	postResendActivation,
	getActivationUser,
	getActivationUserWithCode,
	postForgotPassword,
	postValidateTokenPassword,
	postUpdatePassword,
	postAuthGoogle,
}
